import { ChooseCountryPage } from "@nju/feature-portal-additional-packages";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function InternationalCalls() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="default" spacing="xl">
        <ChooseCountryPage />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
